<template>
  <van-popup
    @click-overlay="handleClose"
    :value="visiable"
    position="right"
    :style="{ height: '100%' }"
    get-container="body"
  >
    <ul class="navbar-wrapper">
      <li>
        <a href="/mobile#page3">关于INDIBA</a
        ><i class="ri-information-line"></i>
      </li>
      <li><a href="/mobile#page4">产品方案</a><i class="ri-stack-line"></i></li>
      <li>
        <a>INDIBA资讯</a><i class="ri-book-2-line"></i>
      </li>
      <li>
        <a href="/mobile/found">找到INDIBA</a><i class="ri-map-pin-2-line"></i>
      </li>
      <li>
        <a href="/mobile/china">INDIBA中国</a><i class="ri-earth-line"></i>
      </li>
      <li><a href="/mobile/hall">名人堂</a><i class="ri-menu-line"></i></li>
      <!-- <li><a href="/mobile/black-vip-zone">黑金专区</a><i class="ri-menu-line"></i></li> -->
      <div class="bottom-wrapper">
        <div class="bottom-phone">
          <i class="ri-phone-line"
            ><a href="tel://010 85951863"> 010 85951863</a></i
          >
        </div>
        <ul class="bottom-icons">
          <li>
            <a
              title="小红书官方"
              target="_blank"
              href="https://www.xiaohongshu.com/user/profile/5bbd95b11071e1000125bece?xhsshare=WeixinSession&appuid=5b57ce9be8ac2b49d16c63cc&apptime=1657071239"
              ><i class="ri-bookmark-fill"></i
            ></a>
          </li>
          <li>
            <a
              title="微博官方"
              target="_blank"
              href="https://m.weibo.cn/u/6606171850?from=10C6195010&wm=20005_0002&sourceType=weixin"
              ><i class="ri-weibo-fill"></i
            ></a>
          </li>
          <li>
            <a
              title="微信公众号"
              target="_blank"
              href="https://mp.weixin.qq.com/s/zJIVCa5C0hbCrSczLZk0qg"
              ><i class="ri-wechat-fill">
                </i
            ></a>
          </li>
        </ul>
      </div>
    </ul>
  </van-popup>
</template>

<script>
export default {
  props: {
    visiable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.navbar-wrapper {
  margin-bottom: 0;
  background: #262626;
  padding-top: 3rem;
  position: relative;
  .bottom-wrapper {
    width: 100%;
    position: absolute;
    bottom: 0;
    .bottom-phone {
      font-size: 1.3rem;
      text-align: center;
      padding: 2rem 0;
      a{
        color: #fff;
      }
    }
    .bottom-icons {
      border-top: 0.01rem solid #fdfdfd;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      li {
        padding: 0.8rem 0;
        a {
          margin-right: 0;
          i {
            font-size: 1.5rem;
          }
        }
      }
    }
  }
  li {
    display: flex;
    justify-content: right;
    align-items: center;
    // font-size: 1rem;
    text-align: right;
    padding-right: 1.5rem;
    // margin-bottom: 8px;
    &:hover {
      background: rgba(255, 255, 255, 0.39);
    }
    a {
      // display: block;
      //   height: 3rem;
      flex: 1;
      margin-right: 0.5rem;
      line-height: 3rem;
      z-index: 2023;
      color: #fff;
    }
    i {
      width: 1.2rem;
      font-size: 1rem;
    }
  }
}
</style>
